import { render, staticRenderFns } from "./OsobaDodatnaAktivnostBase.vue?vue&type=template&id=684201cd&scoped=true&"
import script from "./OsobaDodatnaAktivnostBase.vue?vue&type=script&lang=js&"
export * from "./OsobaDodatnaAktivnostBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684201cd",
  null
  
)

export default component.exports